/**
 * ShellProviders - the nine context providers the shell wraps its markup in,
 * outermost first: session, dialog, roster, targets, combat flow, attacker,
 * chat, handouts and the kill-teams. The panels consume them instead of prop drilling.
 *
 * Extracted from DeathWatchSimulator; the nesting order is unchanged.
 *
 * @param {object} props
 * @param {object} props.contexts - the six values from useShellContexts
 * @param {object} props.shell - the shell scope: reads `chatContextValue` and
 *   `handoutsContextValue`
 * @param {import('react').ReactNode} props.children
 */
import { SessionProvider } from '../../contexts/SessionContext';
import { RosterProvider } from '../../contexts/RosterContext';
import { TargetsProvider } from '../../contexts/TargetsContext';
import { CombatFlowProvider } from '../../contexts/CombatFlowContext';
import { AttackerProvider } from '../../contexts/AttackerContext';
import { ChatProvider } from '../../contexts/ChatContext';
import { HandoutsProvider } from '../../contexts/HandoutsContext';
import { KillTeamsProvider } from '../../contexts/KillTeamsContext';

export default function ShellProviders({ contexts, shell: s, children }) {
  return (
    <SessionProvider value={contexts.sessionContextValue}>
      <RosterProvider value={contexts.rosterContextValue}>
        <TargetsProvider value={contexts.targetsContextValue}>
          <CombatFlowProvider value={contexts.combatFlowContextValue}>
            <AttackerProvider value={contexts.attackerContextValue}>
              <ChatProvider value={s.chatContextValue}>
                <HandoutsProvider value={s.handoutsContextValue}>
                  <KillTeamsProvider value={contexts.killTeamsContextValue ?? null}>{children}</KillTeamsProvider>
                </HandoutsProvider>
              </ChatProvider>
            </AttackerProvider>
          </CombatFlowProvider>
        </TargetsProvider>
      </RosterProvider>
    </SessionProvider>
  );
}
